/* OntologyExplorerButton — bouton autonome « Relations » : ouvre la navigation
 * contextuelle générique (ContextStack + OntologyPanel) sur n'importe quel objet. */
import { useState } from "react";
import { Network } from "lucide-react";
import ContextStack from "@/components/ContextStack";
import { ontologyPanel } from "@/components/OntologyPanel";

export default function OntologyExplorerButton({ otype, oid, label, rootLabel = "Vue", className = "", children }) {
  const [stack, setStack] = useState([]);
  return (
    <>
      <button onClick={(e) => { e.stopPropagation(); setStack([ontologyPanel(otype, oid, label)]); }}
        className={className || "btn-secondary text-xs"}
        data-testid={`ontology-explore-${otype}-${oid}`}
        title="Explorer les relations de cet objet">
        {children || (<><Network className="w-3 h-3" /> Relations</>)}
      </button>
      <ContextStack
        stack={stack}
        rootLabel={rootLabel}
        push={(p) => setStack((st) => [...st, p])}
        onPop={(n) => setStack((st) => st.slice(0, n))}
        onClose={() => setStack([])}
      />
    </>
  );
}
